import React from 'react';
// Mock data for LinkedIn Intent Signal Monitor
export const linkedInPosts = [{
  id: 1,
  author: 'Sarah Johnson',
  authorTitle: 'VP of Marketing at TechGrowth',
  authorImage: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&q=80',
  date: '2 days ago',
  content: "Excited to announce our latest AI-powered marketing analytics platform! After months of development, we're ready to show the world how machine learning can transform your marketing strategy. #AIMarketing #DataAnalytics",
  likes: 87,
  comments: 23,
  shares: 14
}, {
  id: 2,
  author: 'Michael Chen',
  authorTitle: 'CTO at InnovateTech',
  authorImage: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&q=80',
  date: '5 days ago',
  content: 'The future of B2B sales is all about understanding customer intent signals. Our team has been researching how AI can help identify buying signals earlier in the funnel. What signals are you tracking? #B2BSales #CustomerIntent',
  likes: 142,
  comments: 38,
  shares: 27
}, {
  id: 3,
  author: 'Amara Wilson',
  authorTitle: 'Head of Growth at SalesPro',
  authorImage: 'https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&q=80',
  date: '1 week ago',
  content: "Just published my thoughts on how to build a modern outbound sales strategy that doesn't feel pushy or generic. The key? Personalization at scale through intent data. Link in comments! #OutboundSales #Personalization",
  likes: 215,
  comments: 52,
  shares: 43
}, {
  id: 4,
  author: 'David Rodriguez',
  authorTitle: 'Sales Director at CloudScale',
  authorImage: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&q=80',
  date: '2 weeks ago',
  content: 'Our team has been experimenting with different LinkedIn outreach strategies. The results are in: contextual messages based on actual engagement get 3x better response rates than generic templates. #SalesStrategy #LinkedInTips',
  likes: 94,
  comments: 31,
  shares: 18
}];
export const peopleProfiles = [{
  id: 1,
  name: 'Sophie de Jong',
  title: 'AI Consultant at DataMinds',
  company: 'DataMinds',
  image: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&q=80',
  tags: ['AI Interested', 'Decision Maker'],
  interactions: [{
    postId: 1,
    type: 'liked',
    date: '2 days ago'
  }, {
    postId: 2,
    type: 'commented',
    comment: "This is exactly what we're looking into at DataMinds. Would love to compare notes!",
    date: '4 days ago'
  }],
  relevance: 'high',
  status: 'interesting'
}, {
  id: 2,
  name: 'Thomas Wright',
  title: 'Marketing Director at GrowthTech',
  company: 'GrowthTech',
  image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&q=80',
  tags: ['Marketing Tech', 'Budget Holder'],
  interactions: [{
    postId: 1,
    type: 'commented',
    comment: 'Impressive work! How are you handling the data privacy aspects?',
    date: '2 days ago'
  }, {
    postId: 3,
    type: 'liked',
    date: '6 days ago'
  }],
  relevance: 'medium',
  status: 'interesting'
}, {
  id: 3,
  name: 'Elena Petrov',
  title: 'Head of Sales at SaaSTech',
  company: 'SaaSTech',
  image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&q=80',
  tags: ['Sales Target', 'Hot Lead'],
  interactions: [{
    postId: 2,
    type: 'liked',
    date: '5 days ago'
  }, {
    postId: 4,
    type: 'commented',
    comment: "We've seen similar results. Context is everything in modern sales.",
    date: '13 days ago'
  }],
  relevance: 'high',
  status: 'interesting'
}, {
  id: 4,
  name: 'James Miller',
  title: 'Product Manager at TechSolutions',
  company: 'TechSolutions',
  image: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&q=80',
  tags: ['Product Focused', 'Technical'],
  interactions: [{
    postId: 1,
    type: 'liked',
    date: '2 days ago'
  }],
  relevance: 'low',
  status: 'not relevant'
}, {
  id: 5,
  name: 'Natalie Kim',
  title: 'CEO at InnovateAI',
  company: 'InnovateAI',
  image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&q=80',
  tags: ['AI Interested', 'Decision Maker', 'Hot Lead'],
  interactions: [{
    postId: 1,
    type: 'commented',
    comment: 'This looks promising! Would love to see a demo of how this works with unstructured data.',
    date: '1 day ago'
  }, {
    postId: 2,
    type: 'liked',
    date: '4 days ago'
  }],
  relevance: 'high',
  status: 'interesting'
}];
export const aiMessageTemplates = [{
  id: 1,
  personId: 1,
  postId: 1,
  subject: 'Following up on your interest in AI marketing analytics',
  message: "Hi Sophie,\n\nI noticed you engaged with Sarah's post about our new AI-powered marketing analytics platform. Given your role as an AI Consultant at DataMinds, I thought you might be interested in seeing how we're applying machine learning to identify marketing patterns that are often missed by traditional analytics.\n\nWould you be open to a quick 15-minute call next week to discuss how this could potentially complement the work you're doing at DataMinds?\n\nBest regards,\n[Your Name]"
}, {
  id: 2,
  personId: 1,
  postId: 2,
  subject: 'Comparing notes on AI and customer intent signals',
  message: "Hi Sophie,\n\nI saw your thoughtful comment on Michael's post about AI and customer intent signals. Your point about wanting to compare notes caught my attention.\n\nAt [Company], we've been developing some unique approaches to identifying buying signals using AI that might align with what you're working on at DataMinds.\n\nWould you be interested in exchanging ideas? I'd be happy to share some of our findings and learn about your approach as well.\n\nBest,\n[Your Name]"
}, {
  id: 3,
  personId: 2,
  postId: 1,
  subject: 'Addressing your question about data privacy in AI marketing',
  message: "Hi Thomas,\n\nThank you for your comment on Sarah's post about our AI marketing platform. You raised an excellent question about data privacy.\n\nData privacy is actually one of our core design principles. Our platform is built with a privacy-first approach that includes anonymized data processing, transparent data usage policies, and compliance with GDPR and CCPA.\n\nI'd be happy to share more details about how we handle data privacy while still delivering powerful marketing insights. Would you have time for a brief call next week?\n\nBest regards,\n[Your Name]"
}, {
  id: 4,
  personId: 3,
  postId: 4,
  subject: 'Context-driven sales approaches - building on your comment',
  message: "Hi Elena,\n\nI noticed your comment on David's post about contextual LinkedIn outreach. Your point about context being everything in modern sales resonated with me.\n\nAt [Company], we've developed a tool that helps sales teams identify contextual signals from LinkedIn and craft personalized outreach messages. Given your role as Head of Sales at SaaSTech, I thought you might be interested in seeing how this could potentially enhance your team's approach.\n\nWould you be open to a quick demo next week?\n\nBest,\n[Your Name]"
}, {
  id: 5,
  personId: 5,
  postId: 1,
  subject: 'Demo of our AI platform with unstructured data',
  message: "Hi Natalie,\n\nI saw your comment on Sarah's post about our AI-powered marketing platform, particularly your interest in how it handles unstructured data.\n\nAs the CEO of InnovateAI, I imagine you have a strong perspective on the challenges and opportunities in this space. I'd love to show you specifically how our system processes unstructured data to extract meaningful insights that drive marketing decisions.\n\nWould you be interested in a personalized demo focused on the unstructured data capabilities?\n\nBest regards,\n[Your Name]"
}];